import { render, staticRenderFns } from "./MessageGalleryView.vue?vue&type=template&id=c5e278d6&scoped=true&"
import script from "./MessageGalleryView.vue?vue&type=script&lang=ts&"
export * from "./MessageGalleryView.vue?vue&type=script&lang=ts&"
import style0 from "./MessageGalleryView.vue?vue&type=style&index=0&id=c5e278d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e278d6",
  null
  
)

export default component.exports